module.exports = __webpack_public_path__ + "media/stylesheets/images/main/openWaiting/openWaiting_pc_cook2-f4ea24748f981872ffbeafa84ecf415e.png";